import React from 'react';
import ReactFlow, { Background, Controls } from 'react-flow-renderer';
import dagre from 'dagre';
import CustomNode from './CustomNode';
import { Processor } from '@/utils/cartographyUtils.js';

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const nodeWidth = 200;
const nodeHeight = 100;

const getLayoutedElements = (nodes, edges, direction = 'LR') => {
  const isHorizontal = direction === 'LR';
  dagreGraph.setGraph({ rankdir: direction });

  nodes.forEach(node => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  edges.forEach(edge => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  nodes.forEach(node => {
    const nodeWithPosition = dagreGraph.node(node.id);
    node.position = {
      x: nodeWithPosition.x - nodeWidth / 2,
      y: nodeWithPosition.y - nodeHeight / 2,
    };
    node.targetPosition = isHorizontal ? 'left' : 'top';
    node.sourcePosition = isHorizontal ? 'right' : 'bottom';
  });

  return { nodes, edges };
};

const GraphComponent = ({ nodesData, edgesData }) => {
  const results = Processor(nodesData, edgesData);
  console.log(results.nodes, results.edges, 'Processed Nodes and Edges');

  const reactFlowNodes = results.nodes.map(node => ({
    id: node.id,
    type: 'customNode',
    data: {
      label: node.label,
      color: node.color,
      icon: node.icon,
      class: node.class,
    },
  }));

  const reactFlowEdges = results.edges.map(edge => ({
    id: `e${edge.source}-${edge.target}`,
    source: edge.source,
    target: edge.target,
    type: 'default',
    animated: true,
    style: {
      stroke: '#903b08',
      strokeWidth: 2,
      filter: 'drop-shadow(0px 0px 6px #903b08)',
    },
  }));

  const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(
    reactFlowNodes,
    reactFlowEdges,
    'LR'
  );

  const nodeTypes = {
    customNode: CustomNode,
  };

  return (
    <div
      style={{
        height: '500px',
        width: '100%',
        border: '2px solid #ddd',
        borderRadius: '8px',
      }}
    >
      <ReactFlow
        nodes={layoutedNodes}
        edges={layoutedEdges}
        nodeTypes={nodeTypes}
        defaultEdgeOptions={{ type: 'default' }}
        fitView
      >
        <Background color="#aaa" gap={16} />
        <Controls />
      </ReactFlow>
    </div>
  );
};

export default GraphComponent;
